import {
  GET_QA_TRANSCRIPTION_FILE,
  GET_QA_TRANSCRIPTION_FILE_SUCCESS,
  GET_QA_TRANSCRIPTION_FILE_FAILED,
  GET_SUPER_QA_TRANSCRIPTION_FILE,
  GET_SUPER_QA_TRANSCRIPTION_FILE_SUCCESS,
  GET_SUPER_QA_TRANSCRIPTION_FILE_FAILED,
  QA_DESICISION_TRANSCRIPTION_FILE,
  QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS,
  QA_DESICISION_TRANSCRIPTION_FILE_FAILED,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED,
  FETCH_REJECT_REASON_LIST,
  FETCH_REJECT_REASON_LIST_SUCCESS,
  FETCH_REJECT_REASON_LIST_FAILED,
  FETCH_AUDITED_LIST_BY_USER_FAILED,
  FETCH_AUDITED_LIST_BY_USER_SUCCESS,
  FETCH_AUDITED_LIST_BY_USER,
  GET_QA_AUDIO,
  GET_QA_AUDIO_SUCCESS,
  GET_QA_AUDIO_FAILED,
  QA_DESICISION_AUDIO_FILE,
  QA_DESICISION_AUDIO_FILE_SUCCESS,
  QA_DESICISION_AUDIO_FILE_FAILED,
  GET_SQA_AUDIO,
  GET_SQA_AUDIO_SUCCESS,
  GET_SQA_AUDIO_FAILED,
  SQA_DESICISION_AUDIO_FILE,
  SQA_DESICISION_AUDIO_FILE_SUCCESS,
  SQA_DESICISION_AUDIO_FILE_FAILED,
  FETCH_AUDIT_USER_LIST,
  FETCH_AUDIT_USER_LIST_SUCCESS,
  FETCH_AUDIT_USER_LIST_FAILED,
} from "./../constants/constants";

const initialState = {
  success: {
    message: "",
  },
  error: {
    message: "",
  },
  loading: false,
  QACheck: {
    data: [],
  },
  superQACheck: {
    data: [],
  },
  superAuditUserList: {
    data: [],
  },
  rejectReasons: [],
  QADecision: false,
  SQADecision: false,
};

const QAManagement = (state = initialState, action) => {
  switch (action.type) {
    case GET_QA_AUDIO:
      return {
        ...state,
        QACheck: {
          data: [],
        },
        loading: true,
        /*success: {
                        message: ""
                    },
                    error: {
                        message: ""
                    },*/
      };
    case GET_QA_AUDIO_SUCCESS:
      //console.log(action.data)
      return {
        ...state,
        QACheck: {
          data: action.data.data || [],
        },
        loading: false,
      };
    case GET_QA_AUDIO_FAILED:
      return {
        ...state,
      };
    case GET_SQA_AUDIO:
      return {
        ...state,
        superQACheck: {
          data: [],
        },
        loading: true,
        /*success: {
                        message: ""
                    },
                    error: {
                        message: ""
                    },*/
      };
    case GET_SQA_AUDIO_SUCCESS:
      //console.log(action.data)
      return {
        ...state,
        superQACheck: {
          data: action.data.data || [],
        },
        loading: false,
      };
    case GET_SQA_AUDIO_FAILED:
      return {
        ...state,
      };
    case GET_QA_TRANSCRIPTION_FILE:
      return {
        ...state,
        QACheck: {
          data: [],
        },
        loading: true,
        /*success: {
                    message: ""
                },
                error: {
                    message: ""
                },*/
      };
    case GET_QA_TRANSCRIPTION_FILE_SUCCESS:
      //console.log(action.data)
      return {
        ...state,
        QACheck: {
          data: action.data.data || [],
        },
        loading: false,
      };
    case GET_QA_TRANSCRIPTION_FILE_FAILED:
      return {
        ...state,
      };
    case GET_SUPER_QA_TRANSCRIPTION_FILE:
      return {
        ...state,
        superQACheck: {
          data: [],
        },
        loading: true,
        /*success: {
                    message: ""
                },
                error: {
                    message: ""
                },*/
      };
    case GET_SUPER_QA_TRANSCRIPTION_FILE_SUCCESS:
      //console.log(action.data)
      return {
        ...state,
        superQACheck: {
          data: action.data.data || [],
        },
        loading: false,
      };
    case GET_SUPER_QA_TRANSCRIPTION_FILE_FAILED:
      return {
        ...state,
      };
    case QA_DESICISION_TRANSCRIPTION_FILE:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
        QACheck: {
          data: [],
        },
        rejectReasons: [],
      };
    case QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS:
      return {
        ...state,
        QADecision: action.data.data.status,
        success: {
          message: "Transcript updated successfully",
        },
        loading: false,
      };

    case QA_DESICISION_TRANSCRIPTION_FILE_FAILED:
      return {
        ...state,
        error: {
          message: "Transcript update has been failed",
        },
      };

    case SUPER_QA_DESICISION_TRANSCRIPTION_FILE:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
        superQACheck: {
          data: [],
        },
        rejectReasons: [],
      };
    case SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS:
      return {
        ...state,
        SQADecision: action.data.data.status,
        success: {
          message: "Super Transcript Audit updated successfully",
        },
        loading: false,
      };

    case SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED:
      return {
        ...state,
        error: {
          message: "Super Transcript Audit update has been failed",
        },
      };

    case QA_DESICISION_AUDIO_FILE:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
        QACheck: {
          data: [],
        },
        rejectReasons: [],
      };
    case QA_DESICISION_AUDIO_FILE_SUCCESS:
      return {
        ...state,
        QADecision: action.data.data.status,
        success: {
          message: "Transcript updated successfully",
        },
        loading: false,
      };
    case QA_DESICISION_AUDIO_FILE_FAILED:
      return {
        ...state,
        error: {
          message: "Transcript update has been failed",
        },
      };

    case SQA_DESICISION_AUDIO_FILE:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
        superQACheck: {
          data: [],
        },
        rejectReasons: [],
      };
    case SQA_DESICISION_AUDIO_FILE_SUCCESS:
      return {
        ...state,
        SQADecision: action.data.data.status,
        success: {
          message: "Super audio audit updated successfully",
        },
        loading: false,
      };
    case SQA_DESICISION_AUDIO_FILE_FAILED:
      return {
        ...state,
        error: {
          message: "Super audio audit update has been failed",
        },
      };
    case FETCH_REJECT_REASON_LIST:
      return {
        ...state,
      };
    case FETCH_REJECT_REASON_LIST_SUCCESS:
      return {
        ...state,
        rejectReasons: action.data || [],
      };
    case FETCH_REJECT_REASON_LIST_FAILED:
      return {
        ...state,
      };
    case FETCH_AUDITED_LIST_BY_USER:
      return {
        ...state,
        loading: true,
      };
    case FETCH_AUDITED_LIST_BY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        superQACheck: {
          data: action.data || [],
        },
      };
    case FETCH_AUDITED_LIST_BY_USER_FAILED:
      return {
        ...state,
      };
    case FETCH_AUDIT_USER_LIST:
      return {
        ...state,
        // loading: true,
      };
    case FETCH_AUDIT_USER_LIST_SUCCESS:
      return {
        ...state,
        // loading: false,
        superAuditUserList: {
          data: action.data || [],
        },
      };
    case FETCH_AUDIT_USER_LIST_FAILED:
      return {
        ...state,
      };
    default:
      return state;
  }
};
export default QAManagement;
